import React from "react";
import { VerticalTabs } from "../../../../../components";

const VerticalTabsList = () => {
  const tabList = [
    {
      title: "Tab 1",
      page: <Tab1 />,
    },
    {
      title: "Tab 2",
      page: <Tab2 />,
    },
    {
      title: "Tab 3",
      page: <Tab3 />,
    },
  ];

  const tabListValues = [
    {
      title: "Tab 1",
      page: <Tab1 />,
      value: 3,
    },
    {
      title: "Tab 2",
      page: <Tab2 />,
      value: 30,
    },
    {
      title: "Tab 3",
      page: <Tab3 />,
      value: 300,
    },
  ];

  return (
    <div className="pt-2 flex flex-col gap-3 overflow-hidden">
      <VerticalTabs
        tabs={tabList}
        activeColor="primary"
        activeVariant="contained"
      />
      <VerticalTabs
        tabs={tabList}
        activeColor="info"
        activeVariant="outlined"
      />
      <VerticalTabs
        tabs={tabListValues}
        activeColor="danger"
        activeVariant="text"
      />
    </div>
  );
};

export default VerticalTabsList;

const Tab1 = () => {
  return <div className="my-2">Tab-1</div>;
};
const Tab2 = () => {
  return <div className="my-2">Tab-2</div>;
};
const Tab3 = () => {
  return <div className="my-2">Tab-3</div>;
};
